<div class="map">
    <div class="map__layers">
        <div class="map__selector"></div>
    </div>

    <div class="map-info info-panel ui__panel ui__panel--floating">


    </div>
</div>